import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus-circle",
  "use": "plus-circle-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"plus-circle\"><path d=\"M355 230h-73v-73c0-10-10-19-20-19h-12c-10 0-20 9-20 19v73h-73c-10 0-19 10-19 20v16c0 9 9 19 19 19h73v73c0 10 10 20 20 20h16c9 0 19-10 19-20v-76h73c10 0 20-10 20-20v-12c-4-10-10-20-23-20zM256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256S397 0 256 0zm0 483C131 483 29 381 29 256S131 29 256 29s227 102 227 227-102 227-227 227z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus-circle.svg
// module id = 199
// module chunks = 0